import { n as e, r as t, t as n } from "./constants-Ba4J7LQm.js";
import { DsButton as r, DsHeading as i, DsIconButton as a, DsProgressBar as o, DsRadioGroup as s } from "@frontends/ds";
import { DsIcon as c } from "@frontends/ds-icons";
import { marker as l } from "@frontends/util-i18n";
import { formatCurrency as u } from "@frontends/util-utils";
import { Trans as d, useTranslation as f } from "react-i18next";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
import { useCallback as h, useEffect as g, useId as _, useMemo as v, useRef as y, useState as b } from "react";
import { RadioButton as x, RadioField as S } from "react-aria-components";
//#region src/components/BalanceAlert/BalanceAlert.tsx
var C = l("alert.ariaLabel"), w = l("alert.closeAriaLabel"), T = [
	"inline-flex items-center gap-3 py-2 px-4 rounded-lg",
	"bg-backgroundFloating",
	"bg-[linear-gradient(var(--brandPrimaryMuted),var(--brandPrimaryMuted))]",
	"text-textPrimary",
	"text-base",
	"border border-brandPrimarySubtle",
	"[--outline-pulse-color:var(--brandPrimarySubtle)]",
	"outline-2 outline-solid",
	"motion-safe:animate-outline-pulse",
	"cursor-pointer"
].join(" "), E = "inline-flex items-center gap-2 text-left";
function D({ balance: e, currency: t, minBalance: r, onReset: i, onClose: o, className: s }) {
	let { t: l, i18n: h } = f(n);
	return e > r ? null : /* @__PURE__ */ m("div", {
		role: "alert",
		"aria-live": "polite",
		className: s ? `${T} ${s}` : T,
		onClick: i,
		children: [/* @__PURE__ */ m("button", {
			type: "button",
			className: E,
			children: [/* @__PURE__ */ p(c, {
				name: "refresh-ccw",
				size: "sm"
			}), /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(d, {
				i18nKey: `${n}:${C}`,
				values: { value: u(e, t, h.language) },
				components: { balance: /* @__PURE__ */ p("strong", { className: "font-semibold" }) }
			}) })]
		}), o && /* @__PURE__ */ p(a, {
			name: "x",
			"aria-label": l(w),
			onPress: o,
			className: "-me-2.5"
		})]
	});
}
//#endregion
//#region src/utils/isBelowThreshold.ts
function O(t, n) {
	return t < e[n];
}
//#endregion
//#region src/components/ResetDemoPanel/components/AccountRow.tsx
function k({ account: e, maskLogin: t }) {
	let { i18n: n } = f(), r = O(e.balance, e.currency);
	return /* @__PURE__ */ p(S, {
		value: String(e.login),
		children: /* @__PURE__ */ m(x, {
			"data-low-balance": r,
			className: "account-row",
			children: [/* @__PURE__ */ m("span", {
				className: "account-row__id",
				children: ["#", t(e.login)]
			}), /* @__PURE__ */ p("span", {
				className: "account-row__balance",
				children: u(e.balance, e.currency, n.language)
			})]
		})
	});
}
//#endregion
//#region src/components/ResetDemoPanel/components/SumButton.tsx
function A({ amount: e, currency: t }) {
	let { i18n: n } = f();
	return /* @__PURE__ */ p(S, {
		value: String(e),
		className: "sum-field",
		children: /* @__PURE__ */ p(x, {
			className: "sum-button",
			children: u(e, t, n.language)
		})
	});
}
var j = {
	panel: "_panel_1fe84_1",
	header: "_header_1fe84_10",
	sectionBlock: "_sectionBlock_1fe84_18",
	sectionLabel: "_sectionLabel_1fe84_22",
	list: "_list_1fe84_31",
	sums: "_sums_1fe84_76",
	spacer: "_spacer_1fe84_115",
	resetButton: "_resetButton_1fe84_120",
	gateHint: "_gateHint_1fe84_124",
	center: "_center_1fe84_135",
	emptyTitle: "_emptyTitle_1fe84_145",
	emptyDesc: "_emptyDesc_1fe84_150"
};
//#endregion
//#region src/components/ResetDemoPanel/ResetDemoPanel.tsx
function M({ accounts: e, selectedLogin: a, onSelectAccount: l, maskLogin: u, onReset: d, resetAmountsByCurrency: h, isLoading: y, error: x, onRetry: S, hasHeader: C, className: w }) {
	let { t: T } = f(n), [E, D] = b(!1), M = _(), N = _(), P = v(() => e.find((e) => e.login === a) ?? null, [e, a]), F = v(() => P ? h?.[P.currency] ?? t[P.currency] : [], [P, h]), [I, L] = b(null);
	g(() => {
		L(F.at(-1) ?? null);
	}, [F]);
	let R = !P || !O(P.balance, P.currency);
	return y && !e.length ? /* @__PURE__ */ p(o, {
		label: T("panel.loading"),
		size: "sm",
		isIndeterminate: !0,
		className: "w-full p-4"
	}) : x && !y ? /* @__PURE__ */ p("section", {
		className: `${j.panel}${w ? ` ${w}` : ""}`,
		children: /* @__PURE__ */ m("div", {
			className: j.center,
			children: [/* @__PURE__ */ p("p", { children: T("panel.errorState.title") }), S ? /* @__PURE__ */ p(r, {
				variant: "primary",
				size: "md",
				onPress: S,
				children: T("panel.errorState.retry")
			}) : null]
		})
	}) : !y && !x && e.length === 0 ? /* @__PURE__ */ p("section", {
		className: `${j.panel}${w ? ` ${w}` : ""}`,
		children: /* @__PURE__ */ m("div", {
			className: j.center,
			children: [/* @__PURE__ */ p("p", {
				className: j.emptyTitle,
				children: T("panel.emptyState.title")
			}), /* @__PURE__ */ p("p", {
				className: j.emptyDesc,
				children: T("panel.emptyState.description")
			})]
		})
	}) : /* @__PURE__ */ m("section", {
		className: `${j.panel}${w ? ` ${w}` : ""}`,
		children: [
			C ? /* @__PURE__ */ m("header", {
				className: j.header,
				children: [/* @__PURE__ */ p(c, {
					name: "refresh-ccw",
					size: "sm"
				}), /* @__PURE__ */ p(i, {
					level: 2,
					size: "2xs",
					children: T("panel.header")
				})]
			}) : null,
			/* @__PURE__ */ m("div", {
				className: j.sectionBlock,
				children: [/* @__PURE__ */ p("p", {
					id: M,
					className: j.sectionLabel,
					children: T("panel.selectAccount")
				}), /* @__PURE__ */ p(s, {
					"aria-labelledby": M,
					value: a === null ? null : String(a),
					onChange: (e) => l(Number(e)),
					children: /* @__PURE__ */ p("div", {
						className: j.list,
						children: e.map((e) => /* @__PURE__ */ p(k, {
							account: e,
							maskLogin: u
						}, e.login))
					})
				})]
			}),
			/* @__PURE__ */ m("div", {
				className: j.sectionBlock,
				children: [/* @__PURE__ */ p("p", {
					id: N,
					className: j.sectionLabel,
					children: T("panel.resetBalanceTo")
				}), /* @__PURE__ */ p(s, {
					"aria-labelledby": N,
					value: I === null ? null : String(I),
					onChange: (e) => L(Number(e)),
					isDisabled: E,
					children: /* @__PURE__ */ p("div", {
						className: j.sums,
						children: P && F.map((e) => /* @__PURE__ */ p(A, {
							amount: e,
							currency: P.currency
						}, e))
					})
				})]
			}),
			/* @__PURE__ */ p("div", { className: j.spacer }),
			/* @__PURE__ */ p("p", {
				className: j.gateHint,
				"aria-hidden": !(R && P),
				"data-hidden": !(R && P),
				children: T("panel.gate.aboveThreshold")
			}),
			/* @__PURE__ */ p(r, {
				variant: "primary",
				size: "lg",
				iconStart: "refresh-ccw",
				isPending: E,
				isDisabled: R || E || I === null,
				onPress: async () => {
					if (!(!P || I === null || R)) {
						D(!0);
						try {
							await d(P.login, I);
						} finally {
							D(!1);
						}
					}
				},
				className: j.resetButton,
				children: T("panel.resetButton")
			})
		]
	});
}
//#endregion
//#region src/hooks/useDemoAccountsState.ts
function N({ initial: e }) {
	let [t, n] = b(e), r = y(e);
	return r.current !== e && (r.current = e, n(e)), {
		accounts: t,
		applyResetResult: h((e, t) => {
			n((n) => n.map((n) => n.login === e ? {
				...n,
				balance: t
			} : n));
		}, [])
	};
}
//#endregion
//#region src/mocks/fixtures.ts
var P = [
	{
		login: 30001,
		accountType: "demo",
		currency: "USD",
		balance: 5.42,
		caption: "Standard Trading Account"
	},
	{
		login: 30018,
		accountType: "demo",
		currency: "USD",
		balance: 8200,
		caption: "USD RAW Trading Account"
	},
	{
		login: 30015,
		accountType: "demo",
		currency: "THB",
		balance: 2150,
		caption: "THB LIMITLESS"
	}
], F = {
	default: P,
	allHealthy: [{
		login: 40001,
		accountType: "demo",
		currency: "USD",
		balance: 1e4,
		caption: "Healthy USD"
	}, {
		login: 40002,
		accountType: "demo",
		currency: "EUR",
		balance: 5e3,
		caption: "Healthy EUR"
	}],
	allLow: [{
		login: 41001,
		accountType: "demo",
		currency: "USD",
		balance: 4.2,
		caption: "Low USD"
	}, {
		login: 41002,
		accountType: "demo",
		currency: "EUR",
		balance: 7.5,
		caption: "Low EUR"
	}],
	mixedCurrencies: [
		{
			login: 42001,
			accountType: "demo",
			currency: "USD",
			balance: 5,
			caption: "Low USD"
		},
		{
			login: 42002,
			accountType: "demo",
			currency: "EUR",
			balance: 5,
			caption: "Low EUR"
		},
		{
			login: 42003,
			accountType: "demo",
			currency: "GBP",
			balance: 5,
			caption: "Low GBP"
		},
		{
			login: 42004,
			accountType: "demo",
			currency: "JPY",
			balance: 700,
			caption: "Low JPY"
		},
		{
			login: 42005,
			accountType: "demo",
			currency: "THB",
			balance: 100,
			caption: "Low THB"
		}
	],
	empty: []
}, I = class extends Error {
	kind;
	constructor(e, t) {
		super(e), this.kind = t;
	}
};
function L(n = {}) {
	let r = n.latencyMs ?? 300, i = n.failureRate ?? 0, a = n.failureKind ?? "generic", o = new Map((n.accounts ?? P).map((e) => [e.login, { ...e }])), s = null, c = () => new Promise((e) => setTimeout(e, r)), l = () => i > 0 && Math.random() < i;
	return {
		list: () => (s ||= (async () => (await c(), Array.from(o.values()).map((e) => ({ ...e }))))(), s),
		reset: async (n, r) => {
			if (await c(), l()) throw new I(`Mock failure (${a})`, a);
			let i = o.get(n);
			if (!i) throw new I(`Login ${n} not found`, "generic");
			let s = e[i.currency];
			if (i.balance > s) throw new I(`Balance ${i.balance} ${i.currency} above threshold ${s}`, "rejected");
			if (!t[i.currency].includes(r)) throw new I(`Amount ${r} not allowed for ${i.currency}`, "generic");
			return o.set(n, {
				...i,
				balance: r
			}), { newBalance: r };
		}
	};
}
//#endregion
export { D as BalanceAlert, n as FEATURE_DEMO_BALANCE_NAMESPACE, e as MIN_BALANCE_BY_CURRENCY, P as MOCK_DEMO_ACCOUNTS, F as MOCK_DEMO_ACCOUNTS_VARIANTS, t as RESET_AMOUNTS_BY_CURRENCY, M as ResetDemoPanel, L as createMockDemoApi, O as isBelowThreshold, N as useDemoAccountsState };
